import React from 'react';
import Shape from 'ati-ui-react/components/Shape';
import Skeleton from 'ati-ui-react/components/Skeleton';
import uuidv1 from 'uuid/v1';
import * as styles from './RatingFirmsLoadingMobile.scss';
import RatingHeaderLoading from '../RatingHeaderLoading';

const RatingFirmsLoadingMobile = ({ rowsCount }) => (
  <div>
    <div className={styles.firmsContainer}>
      <RatingHeaderLoading isMobile />
      <div className={styles.rowsContainer}>
        {
          [...Array(rowsCount)].map(() => (
            <Shape
              shadow
              className={styles.shape}
              key={uuidv1()}
            >
              <div className={styles.position}>
                <Skeleton className={styles.fakePosition} />
              </div>

              <div className={styles.ratingRowLoadingMobileContainer}>
                <Skeleton className={styles.first} />
                <Skeleton className={styles.second} />

                <div className={styles.iconsLoadingContainer}>
                  <Skeleton className={styles.iconLoading} />
                  <Skeleton className={styles.iconLoading} />
                  <Skeleton className={styles.iconLoading} />
                  <Skeleton className={styles.iconLoading} />
                </div>

                <Skeleton className={styles.fourth} />
                <Skeleton className={styles.fifth} />
              </div>
            </Shape>
          ))
        }
      </div>
    </div>
  </div>
);

export default RatingFirmsLoadingMobile;
